import RegExpUtils from '../text/RegExpUtils';
RegExp.escape = RegExpUtils.escape;
//# sourceMappingURL=RegExpExtensions.js.map